var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXmarkLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.6 15.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #666;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.37,15.37c-.31.31-.8.31-1.1,0l-6.47-6.47L1.33,15.37c-.31.31-.8.31-1.1,0-.31-.31-.31-.8,0-1.1l6.47-6.47L.23,1.33C-.08,1.02-.08.53.23.23.54-.08,1.03-.08,1.33.23l6.47,6.47L14.27.23c.31-.31.8-.31,1.1,0,.31.31.31.8,0,1.1l-6.47,6.47,6.47,6.47c.31.3.31.8,0,1.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXmarkLight);
export default __webpack_public_path__ + "static/media/iconXmarkLight.dc158fcc33cf01e1072798d7448b6496.svg";
export { ForwardRef as ReactComponent };